module.exports = __webpack_public_path__ + "static/media/hlogo.28060189.png";